import React from 'react';
import { Box, Button, Card, Typography, makeStyles } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { pauseConvertMovie } from 'redux/actions/Convert';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';

const activeStateMap = {
  in_progress: 'در حال پردازش',
  not_in_queue: 'در حال آماده سازی',
};

const deactiveStateMap = {
  processed: 'همگام سازی شده',
  failed: 'پردازش ناموفق',
};

const useStyles = makeStyles(theme => ({
  cardRoot: {
    padding: 14,
    backgroundColor: '#7D82AE40',
    marginBottom: 25,
  },
  qualityCard: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    backgroundColor: '#FFFFFF40',
  },
  actionCard: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 15,
  },
}));

const ConvertInfoBox = ({ item }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleDelete = () => {
    Swal.fire({
      title: `آیا از حذف ${item.quality.replace(`_`, ``)} مطمعن هستید؟`,
      icon: 'warning',
      iconHtml: '؟',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'حذف',
      cancelButtonText: 'لغو',
      showCancelButton: true,
      showCloseButton: true,
      preConfirm: () => dispatch(pauseConvertMovie(item.id)),
    });
  };

  const activeLentgh = item.active_tapture_converts.length;
  const deactiveLentgh = item.deactive_tapture_converts.length;

  const actvieStatus = () => {
    const lastState = activeLentgh > 0 ? item.active_tapture_converts[activeLentgh - 1] : null;
    return lastState ? activeStateMap[lastState?.status] : '';
  };

  const deactiveStatus = () => {
    const lastState = deactiveLentgh > 0 ? item.deactive_tapture_converts[deactiveLentgh - 1] : null;
    return lastState ? deactiveStateMap[lastState?.status] : '';
  };

  return (
    <Card className={classes.cardRoot}>
      <Card className={classes.qualityCard}>
        <Typography variant="h5">کیفیت</Typography>
        <Typography variant="h2"> {item.quality.replace(`_`, ``)}</Typography>
      </Card>
      <Box display="inline-flex" className={classes.actionCard}>
        <Button onClick={handleDelete} endIcon={<DeleteIcon>send</DeleteIcon>}>
          حذف کردن
        </Button>
        <Typography color={'inherit'}>
          {actvieStatus() !== '' ? actvieStatus() : deactiveStatus() !== '' ? deactiveStatus() : 'تبدیل غیر تپچری'}
        </Typography>
      </Box>
    </Card>
  );
};

export default ConvertInfoBox;
